/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationSettings } from '../../models/application-settings';

export interface AppSettingGetApplicationSettings$Params {
}

export function appSettingGetApplicationSettings(http: HttpClient, rootUrl: string, params?: AppSettingGetApplicationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettings>> {
  const rb = new RequestBuilder(rootUrl, appSettingGetApplicationSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationSettings>;
    })
  );
}

appSettingGetApplicationSettings.PATH = '/api/AppSetting/ApplicationSettings';
